import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "X5RKK8WWM7"; // tu ID real

export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", GA_ID, {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null; // No renderiza nada
}
